import { render } from "./CButton.vue?vue&type=template&id=498bc1ae&scoped=true"
import script from "./CButton.vue?vue&type=script&lang=js"
export * from "./CButton.vue?vue&type=script&lang=js"

import "./CButton.vue?vue&type=style&index=0&id=498bc1ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498bc1ae"]])

export default __exports__